import React from 'react';
import '../styles/EmployeeApp.css';

const features = [
  {
    colour: 'blue',
    title: 'Instant tiredness scoring',
    desc: 'Based on sleep, wakefulness, and reaction time using the Stanford Sleepiness Scale.',
  },
  {
    colour: 'green',
    title: 'Evidence-based fatigue algorithms',
    desc: 'Built on peer-reviewed research into fatigue, alertness, and human performance.',
  },
  {
    colour: 'orange',
    title: 'Personal risk awareness without judgement',
    desc: 'Empowers employees to make sensible choices for themselves — no data shared individually.',
  },
];

function EmployeeApp() {
  return (
    <section className="employee-app">
      <div className="section-container">
        <div className="employee-app-grid">

          {/* Text */}
          <div className="employee-app-text">
            <span className="section-tag">For employees</span>
            <h2>Personal alertness app for your team</h2>
            <p className="employee-app-lead">
              Empower your team to monitor their own fatigue risk in real time with a quick,
              science-backed check-in.
            </p>

            <div className="employee-app-features">
              {features.map(({ colour, title, desc }) => (
                <div key={title} className="employee-feature-row">
                  <div className={`employee-feature-dot ${colour}`} />
                  <div>
                    <strong>{title}</strong>
                    <p>{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Visual */}
          <div className="employee-app-visual">
            <div className="employee-app-phone">
              <div className="phone-screen">
                <div className="phone-header">
                  <span className="phone-title">How are you feeling?</span>
                  <span className="phone-subtitle">Quick check-in</span>
                </div>

                <div className="phone-metric">
                  <span className="phone-metric-label">Tiredness score</span>
                  <div className="phone-score-bar">
                    <div className="phone-score-fill blue" style={{ width: '35%' }} />
                  </div>
                  <span className="phone-score-value blue">Low</span>
                </div>

                <div className="phone-metric">
                  <span className="phone-metric-label">Happiness</span>
                  <div className="phone-score-bar">
                    <div className="phone-score-fill green" style={{ width: '78%' }} />
                  </div>
                  <span className="phone-score-value green">4.2 / 5</span>
                </div>

                <div className="phone-metric">
                  <span className="phone-metric-label">Reaction time</span>
                  <div className="phone-score-bar">
                    <div className="phone-score-fill orange" style={{ width: '60%' }} />
                  </div>
                  <span className="phone-score-value orange">248ms</span>
                </div>

                <div className="phone-cta">Submit check-in</div>
              </div>
            </div>
          </div>

        </div>
      </div>
          <img
          src="/Zella flower shape@3x.png"
          alt=""
          aria-hidden="true"
          className="employee-app-flower"
        />
    </section>
  );
}

export default EmployeeApp;
